import { Phone } from "lucide-react";
import { CONFIG } from "@/lib/api";

/**
 * FloatingCall — express-service Call Now floater.
 * Stacked ABOVE the WhatsApp badge (bottom-24) so both are visible on desktop.
 * On mobile the persistent MobileStickyCTA already exposes a Call button, so
 * this floater is desktop-only to avoid double stacking.
 */
export default function FloatingCall() {
  return (
    <a
      data-testid="floating-call"
      href={`tel:${CONFIG.phoneRaw}`}
      className="hidden md:flex fixed bottom-24 right-6 z-40 items-center gap-3 pl-4 pr-5 py-3 rounded-full shadow-2xl group"
      style={{
        background: "var(--pcv-gold)",
        color: "#071628",
        boxShadow:
          "0 12px 34px -12px rgba(63,184,206,0.55), 0 0 0 0 rgba(63,184,206,0.6)",
      }}
      aria-label={`Call now for express service · ${CONFIG.phone}`}
    >
      <span className="relative flex items-center justify-center w-6 h-6">
        <span
          className="absolute inline-flex h-full w-full rounded-full opacity-60 animate-ping"
          style={{ background: "rgba(255,255,255,0.7)" }}
        />
        <Phone className="relative w-5 h-5" strokeWidth={2.5} />
      </span>
      <span className="flex flex-col leading-tight">
        <span
          className="text-[9px] uppercase tracking-[0.22em] font-semibold opacity-80"
        >
          Express Service
        </span>
        <span
          className="text-[13px] font-semibold tracking-wide"
          style={{ fontVariantNumeric: "tabular-nums" }}
        >
          {CONFIG.phone}
        </span>
      </span>
    </a>
  );
}
